<template>
  <div id="myPersonalRoleList">
    <div>
      <div class="allSearch">
        <div class="newSearch d_flex">
          <div>
            <p><input @keyup.enter="getAll(1)" class="allInput" type="text" placeholder="姓名、邮箱" v-model="postData.keywords"></p>
            <p><button class="redButton" @click="getAll(1)">搜索</button></p>
          </div>
          <div style="width: auto">
            <button class="redButton m_r_10" @click="allAdd('new')">添加角色</button>
          </div>
        </div>
      </div>
      <div class="allTablePlace">
        <div>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>姓名</th>
              <th>邮箱</th>
              <th>角色</th>
              <th>操作</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td>{{item.userName}}</td>
              <td>{{item.email}}</td>
              <td :title="item.role" class="NoWrap" style="max-width: 200px">{{item.role}}</td>
              <td width="10%"><div class="icon more iconfont icongengduo moreOperations">
                <ul>
                  <li @click="allEdit(item)">编辑角色</li>
                  <li @click="allDelt(item.userId)">删除角色</li>
                </ul>
              </div></td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="totalPage !== 0" v-on:on-getList="getAll($event)" :totalCount="totalCount" :totalPage="totalPage" :page="page" :explain="0"></page>
      </div>
    </div>
    <model v-if="dominUserModel" :buttonType="0" :title="modelTitle" :minWidth="'600px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()" :showAuto="true">
      <div style="padding:10px 40px;">
        <ul class="allUL">
          <li v-if="showSeltUser">
            <span style="font-size:16px;width: auto">选择用户</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10 p_r">
              <input type="text" class="allInput" placeholder="请输入姓名/邮箱搜索" style="width: calc(100% - 12px)" @input="searchUser" v-model="sechUser">
              <div class="p_a assSerch" style="top: 30px;left: 0px;z-index: 10" v-if="isUser">
                <p v-if="myUserList.length > 0" :key="index" v-for="(item, index) in myUserList" class="userList" @click="onSerUser(item)">{{ item.chineseName }} - {{item.email}}</p>
                <p v-if="myUserList.length === 0">暂无数据</p>
              </div>
            </div>
          </li>
          <li>
            <span style="font-size:16px;width: auto">用户姓名</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10">
              <input maxlength="50" v-model="userData.userName" type="text" class="allInput" style="width: calc(100% - 12px);" disabled/>
            </div>
          </li>
          <li>
            <span style="font-size:16px;width: auto">用户邮箱</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10">
              <input maxlength="50" v-model="userData.email" type="text" class="allInput" style="width: calc(100% - 12px);" disabled/>
            </div>
          </li>
          <li>
            <span style="font-size:16px;width: auto">选择角色</span>
            <div style="display: inline-block;vertical-align: middle;width: calc(100% - 80px)" class="m_l_10">
              <allSelect :chooseData="roleMenu" :multiple="true" v-model="roleData" :needReturn="'id'" :placeholder="'请选择角色'" :matchValue="'role'" :showValue="'{{role}}'" :width="'420'">
              </allSelect>
            </div>
          </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
let allTimeOut
export default {
  name: 'mainDateList',
  data () {
    return {
      modelTitle: '',
      baseUrl: process.env.config.baseUrl,
      dominUserList: [],
      showSendPicker: false,
      dominUserModel: false,
      allPageDto: {
        allDominListTotalPage: 0,
        allDominListTotalCount: 0,
        allDominListPage: 1
      },
      OpenModel: false,
      showModel: false,
      title: '',
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      postData: {
        keywords: '',
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      roleMenu: [],
      roleData: '',
      userData: {
        userName: '',
        userId: '',
        email: ''
      },
      showSeltUser: false,
      sechUser: '',
      myUserList: [],
      isUser: false,
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin')
    }
  },
  created () {
    // this.getAllUserList()
    this.getAll(1)
    this.getAllRoles()
  },
  methods: {
    getAllUserList (name) {
      let data = {
        pageIndex: 1,
        pageSize: 10,
        keywords: name
      }
      this.$axiox.post('/api/employee/GetAllEmployees', data).then(msg => {
        // this.myUserList = msg
        let allUser = msg
        this.$axiox.get('/api/employeerole/GetEmployeeRolesList/GetEmployeeRolesList?pageIndex=1&pageSize=99999').then(p => {
          for (let i = 0; i < allUser.length; i++) {
            this.$set(allUser[i], 'roleIds', [])
            for (let j = 0; j < p.length; j++) {
              if (allUser[i].employeeId === p[j].userId) {
                allUser[i].roleIds = p[j].roleIds
              }
            }
          }
        })
        this.myUserList = allUser
      })
    },
    searchUser () {
      clearTimeout(allTimeOut)
      allTimeOut = setTimeout(p => {
        if (this.sechUser !== '') {
          this.roleData = ''
          this.userData = {
            userName: '',
            userId: '',
            email: ''
          }
          this.getAllUserList(this.sechUser)
          this.isUser = true
        } else {
          this.sechUser = ''
          this.roleData = ''
          this.userData = {
            userName: '',
            userId: '',
            email: ''
          }
          this.isUser = false
        }
      }, 1000)
    },
    onSerUser (item) {
      console.log(item)
      this.sechUser = item.chineseName
      this.userData = {
        userName: item.chineseName,
        userId: item.employeeId,
        email: item.email
      }
      this.roleData = item.roleIds.join(',') || ''
      this.isUser = false
    },
    getAllRoles () {
      this.$axiox.get('/api/employeerole/Gets?pageIndex=1&pageSize=9999').then(p => {
        this.roleMenu = p
      })
    },
    getAll (PageNum) {
      this.postData.pageIndex = PageNum
      let url = this.$commonJs.returnQuery('/api/employeerole/GetEmployeeRolesList/GetEmployeeRolesList', this.postData)
      this.$axiox.getList(url).then(msg => {
        this.page = PageNum
        // console.log(msg)
        this.myList = msg.data
        this.totalPage = Math.ceil(msg.total / this.postData.pageSize)
        this.totalCount = msg.total
      })
    },
    allAdd () {
      this.modelTitle = '添加角色'
      this.dominUserModel = true
      this.showSeltUser = true
      this.isUser = false
      this.myUserList = []
      this.roleData = ''
      this.sechUser = ''
      this.userData = {
        userName: '',
        userId: '',
        email: ''
      }
    },
    allEdit (item) {
      this.modelTitle = '编辑角色'
      this.roleData = item.roleIds.join(',')
      this.userData = JSON.parse(JSON.stringify(item))
      this.dominUserModel = true
      this.showSeltUser = false
    },
    allDelt (id) {
      this.$commonJs.doubleComfirm({
        content: '确定删除此用户下所有角色？',
        successFun: msg => {
          this.$axiox.post('/api/employeerole/RemoveUserRoles/RemoveUserRoles?empolyeeId=' + id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAll(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    },
    confirModel () {
      if (this.userData.userId === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择用户',
          stayTime: 5
        })
        return
      }
      if (this.roleData === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择角色',
          stayTime: 5
        })
        return
      }
      let data = []
      data = this.roleData.split(',')
      data = data.map(p => {
        return +p
      })
      this.$axiox.post('/api/employeerole/UserUpSetRoles/UserUpSetRoles?empolyeeId=' + this.userData.userId, data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '修改成功',
          stayTime: 5
        })
        this.getAll(this.page)
        this.dominUserModel = false
      })
    },
    cancelModel () {
      this.dominUserModel = false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/permissionManger/myPersonalRoleList.vue